<script setup>
import { computed } from 'vue'
const props = defineProps({
	updates: {
		type: Object,
		default: () => ({})
	}
})

function standardizeUpdates(updates) {
	if (updates.added || updates.deleted) {
		return updates
	}
	// Below formatting for old updates
	const standardUpdates = {}
	for (const ups of updates) {
		for (const update_type in ups) {
			const { section_type, section_start_page: start, section_end_page: end } = ups[update_type]
			standardUpdates[update_type] = [...(standardUpdates[update_type] || []), { section_type, start, end }]
		}
	}
	return standardUpdates
}

const clean_updates = computed(() => standardizeUpdates(props.updates))
</script>

<template>
	<div v-for="(value, key) in clean_updates" :key="key">
		<div v-if="value?.length" class="secondary-text detail">
			<span class="tiny-text">{{ key }}</span>
			<span v-for="({ section_type, start, end }, indx) in value" :key="`${key}_${indx}`" :class="key"> {{ section_type }}: {{ start }} - {{ end }} </span>
		</div>
	</div>
</template>
<style lang="less" scoped>
.detail {
	padding: @micro @large;
	display: flex;
	flex-direction: column;

	.tiny-text {
		color: @gray-80;
		text-transform: capitalize;
	}
	.deleted {
		text-decoration: line-through;
		color: @gray-80;
	}
}

.added,
.deleted {
	margin: @nano 0;
}
</style>
